import React from 'react';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import { translate } from 'react-i18next';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';
import { Redirect } from 'react-router-dom';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

class ProductCreate extends React.Component {
  constructor(props) {
    super(props);
    this.initialState = {
      name: '',
      description: '',
      nameError: '',
      redirectTo: '',
      vat: '0'
    };

    this.state = {
      ...this.initialState
    };
  }

  handleNameChange = (event, name) => this.setState({name, nameError: ''})
  handleDescriptionChange = (event, description) => this.setState({description})
  handleVatChange = (event, index, vat) => this.setState({vat})

  validateName = () => {
    const {t} = this.props;
    if (!this.state.name) {
      this.setState({nameError: t('product.nameRequired')});
      return false;
    }
    return true;
  }

  handleClose = () => {
    this.setState(this.initialState);
    this.props.handleClose();
  }

  handleSave = () => {
    const {firebase} = this.props;

    const valid = [this.validateName].map((fn) => fn()).every(x => (x));
    if (!valid) return;

    const product = {
      name: this.state.name,
      description: this.state.description,
      vat: this.state.vat
    };

    var pushRef = firebase.database()
      .ref('portfolio/' + this.props.category + '/products/')
      .push(product);

    this.setState({redirectTo: pushRef.key});

  }
  render() {
    if (this.state.redirectTo) {
      return (
        <Redirect to={`/admin/portfolio/${this.props.category}/${this.state.redirectTo}`} push/>
      );
    }

    const {t} = this.props;
    const actions = [
      <FlatButton
        label={t('cancel')}
        onTouchTap={this.handleClose}
      />,
      <RaisedButton
        label={t('submit')}
        type="submit"
        primary={true}
        onTouchTap={this.handleSave}
      />,
    ];

    return (
      <Dialog
          title={t('product.create')}
          open={this.props.open}
          onRequestClose={this.handleClose}
          actions={actions}
        >
          <TextField
            hintText={t('product.name')}
            floatingLabelText={t('product.name')}
            onBlur={this.validateName}
            errorText={this.state.nameError}
            onChange={this.handleNameChange}
            value={this.state.name}
            />
          <br />
          <TextField
            hintText={t('product.description')}
            floatingLabelText={t('product.description')}
            onChange={this.handleDescriptionChange}
            value={this.state.description}
          />
          <br />
          <SelectField
            autoWidth={true}
            floatingLabelText={t('product.vat')}
            value={this.state.vat}
            onChange={this.handleVatChange}>
            <MenuItem value={'0'} primaryText="0 %" />
            <MenuItem value={'10'} primaryText="10 %" />
            <MenuItem value={'14'} primaryText="14 %" />
            <MenuItem value={'24'} primaryText="24 %" />
          </SelectField>
        </Dialog>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(ProductCreate);



// WEBPACK FOOTER //
// ./src/Admin/ProductCreate.js